import { useEffect, useState, useRef } from 'react';

const useDynamicHeight = () => {
  const [dynamicHeight, setDynamicHeight] = useState('100vh');
  const [navHeight, setNavHeight] = useState(70);
  const prevDevicePixelRatio = useRef(window.devicePixelRatio);

  const calculateHeight = () => {
    const navbar = document.querySelector('.navbar-expand-lg');
    const subMsgBar = document.querySelector('.subscribe-msg');
    const announcementBar = document.querySelector('.announcements-bar');

    let totalHeight = 0;
    if (navbar) totalHeight += navbar.offsetHeight;
    if (subMsgBar) totalHeight += subMsgBar.offsetHeight;
    if (announcementBar && announcementBar.offsetParent !== null) {
      totalHeight += announcementBar.offsetHeight;
    }

    setNavHeight(totalHeight);
    setDynamicHeight(`calc(100vh - ${totalHeight}px)`);
  };

  useEffect(() => {
    const handleResizeOrZoom = () => {
      if (window.devicePixelRatio !== prevDevicePixelRatio.current) {
        prevDevicePixelRatio.current = window.devicePixelRatio;
        calculateHeight(); // zoom changed
      } else {
        calculateHeight(); // normal resize
      }
    };

    const targets = [
      document.querySelector('.navbar-expand-lg'),
      document.querySelector('.subscribe-msg'),
      document.querySelector('.announcements-bar'),
    ].filter(Boolean);

    const observers = targets.map((el) => {
      const obs = new ResizeObserver(() => calculateHeight());
      obs.observe(el);
      return obs;
    });

    // Watch DOM changes (helps detect when announcement bar is removed)
    const mutationObserver = new MutationObserver(() => calculateHeight());
    mutationObserver.observe(document.body, { childList: true, subtree: true });

    calculateHeight();
    window.addEventListener('resize', handleResizeOrZoom);

    return () => {
      window.removeEventListener('resize', handleResizeOrZoom);
      observers.forEach((o) => o.disconnect());
      mutationObserver.disconnect();
    };
  }, []);

  return { dynamicHeight, navHeight };
};

export default useDynamicHeight;
